export default "__VITE_ASSET__BMFNujBr__"